import { render } from "./Preloader.vue?vue&type=template&id=3efa4dd6&scoped=true&ts=true"
import script from "./Preloader.vue?vue&type=script&lang=ts"
export * from "./Preloader.vue?vue&type=script&lang=ts"

import "./Preloader.vue?vue&type=style&index=0&id=3efa4dd6&scoped=true&lang=less"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3efa4dd6"]])

export default __exports__